import React, { createElement } from 'react';
import { jsx } from 'react/jsx-runtime';
import 'react-dom';
import { applyPolyfills, defineCustomElements } from '@se/web-ui/loader';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var dashToPascalCase = function dashToPascalCase(str) {
  return str.toLowerCase().split('-').map(function (segment) {
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  }).join('');
};
var camelToDashCase = function camelToDashCase(str) {
  return str.replace(/([A-Z])/g, function (m) {
    return "-".concat(m[0].toLowerCase());
  });
};

var attachProps = function attachProps(node, newProps) {
  var oldProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // some test frameworks don't render DOM elements, so we test here to make sure we are dealing with DOM first
  if (node instanceof Element) {
    // add any classes in className to the class list
    var className = getClassName(node.classList, newProps, oldProps);

    if (className !== '') {
      node.className = className;
    }

    Object.keys(newProps).forEach(function (name) {
      if (name === 'children' || name === 'style' || name === 'ref' || name === 'class' || name === 'className' || name === 'forwardedRef') {
        return;
      }

      if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
        var eventName = name.substring(2);
        var eventNameLc = eventName[0].toLowerCase() + eventName.substring(1);

        if (!isCoveredByReact(eventNameLc)) {
          syncEvent(node, eventNameLc, newProps[name]);
        }
      } else {
        node[name] = newProps[name];
        var propType = typeof newProps[name];

        if (propType === 'string') {
          node.setAttribute(camelToDashCase(name), newProps[name]);
        }
      }
    });
  }
};
var getClassName = function getClassName(classList, newProps, oldProps) {
  var newClassProp = newProps.className || newProps["class"];
  var oldClassProp = oldProps.className || oldProps["class"]; // map the classes to Maps for performance

  var currentClasses = arrayToMap(classList);
  var incomingPropClasses = arrayToMap(newClassProp ? newClassProp.split(' ') : []);
  var oldPropClasses = arrayToMap(oldClassProp ? oldClassProp.split(' ') : []);
  var finalClassNames = []; // loop through each of the current classes on the component
  // to see if it should be a part of the classNames added

  currentClasses.forEach(function (currentClass) {
    if (incomingPropClasses.has(currentClass)) {
      // add it as its already included in classnames coming in from newProps
      finalClassNames.push(currentClass);
      incomingPropClasses["delete"](currentClass);
    } else if (!oldPropClasses.has(currentClass)) {
      // add it as it has NOT been removed by user
      finalClassNames.push(currentClass);
    }
  });
  incomingPropClasses.forEach(function (s) {
    return finalClassNames.push(s);
  });
  return finalClassNames.join(' ');
};
/**
 * Transforms a React event name to a browser event name.
 */

var transformReactEventName = function transformReactEventName(eventNameSuffix) {
  switch (eventNameSuffix) {
    case 'doubleclick':
      return 'dblclick';
  }

  return eventNameSuffix;
};
/**
 * Checks if an event is supported in the current execution environment.
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */

var isCoveredByReact = function isCoveredByReact(eventNameSuffix) {
  if (typeof document === 'undefined') {
    return true;
  } else {
    var eventName = 'on' + transformReactEventName(eventNameSuffix);
    var isSupported = (eventName in document);

    if (!isSupported) {
      var element = document.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }

    return isSupported;
  }
};
var syncEvent = function syncEvent(node, eventName, newEventHandler) {
  var eventStore = node.__events || (node.__events = {});
  var oldEventHandler = eventStore[eventName]; // Remove old listener so they don't double up.

  if (oldEventHandler) {
    node.removeEventListener(eventName, oldEventHandler);
  } // Bind new listener.


  node.addEventListener(eventName, eventStore[eventName] = function handler(e) {
    if (newEventHandler) {
      newEventHandler.call(this, e);
    }
  });
};

var arrayToMap = function arrayToMap(arr) {
  var map = new Map();
  arr.forEach(function (s) {
    return map.set(s, s);
  });
  return map;
};

var setRef = function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref != null) {
    // Cast as a MutableRef so we can assign current
    ref.current = value;
  }
};
var mergeRefs = function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (value) {
    refs.forEach(function (ref) {
      setRef(ref, value);
    });
  };
};
var createForwardRef = function createForwardRef(ReactComponent, displayName) {
  var forwardRef = function forwardRef(props, ref) {
    return jsx(ReactComponent, Object.assign({}, props, {
      forwardedRef: ref
    }), void 0);
  };

  forwardRef.displayName = displayName;
  return /*#__PURE__*/React.forwardRef(forwardRef);
};

var createReactComponent = function createReactComponent(tagName, ReactComponentContext, manipulatePropsFunction, defineCustomElement) {
  if (defineCustomElement !== undefined) {
    defineCustomElement();
  }

  var displayName = dashToPascalCase(tagName);

  var ReactComponent = /*#__PURE__*/function (_React$Component) {
    _inherits(ReactComponent, _React$Component);

    var _super = _createSuper(ReactComponent);

    function ReactComponent(props) {
      var _this;

      _classCallCheck(this, ReactComponent);

      _this = _super.call(this, props);

      _this.setComponentElRef = function (element) {
        _this.componentEl = element;
      };

      return _this;
    }

    _createClass(ReactComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate(this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        attachProps(this.componentEl, this.props, prevProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _a = this.props,
            children = _a.children,
            forwardedRef = _a.forwardedRef,
            style = _a.style,
            className = _a.className,
            ref = _a.ref,
            cProps = __rest(_a, ["children", "forwardedRef", "style", "className", "ref"]);

        var propsToPass = Object.keys(cProps).reduce(function (acc, name) {
          var value = cProps[name];

          if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
            var eventName = name.substring(2).toLowerCase();

            if (typeof document !== 'undefined' && isCoveredByReact(eventName)) {
              acc[name] = value;
            }
          } else {
            // we should only render strings, booleans, and numbers as attrs in html.
            // objects, functions, arrays etc get synced via properties on mount.
            var type = typeof value;

            if (type === 'string' || type === 'boolean' || type === 'number') {
              acc[camelToDashCase(name)] = value;
            }
          }

          return acc;
        }, {});

        if (manipulatePropsFunction) {
          propsToPass = manipulatePropsFunction(this.props, propsToPass);
        }

        var newProps = Object.assign(Object.assign({}, propsToPass), {
          ref: mergeRefs(forwardedRef, this.setComponentElRef),
          style: style
        });
        /**
         * We use createElement here instead of
         * React.createElement to work around a
         * bug in Vite (https://github.com/vitejs/vite/issues/6104).
         * React.createElement causes all elements to be rendered
         * as <tagname> instead of the actual Web Component.
         */

        return /*#__PURE__*/createElement(tagName, newProps, children);
      }
    }], [{
      key: "displayName",
      get: function get() {
        return displayName;
      }
    }]);

    return ReactComponent;
  }(React.Component); // If context was passed to createReactComponent then conditionally add it to the Component Class


  if (ReactComponentContext) {
    ReactComponent.contextType = ReactComponentContext;
  }

  return createForwardRef(ReactComponent, displayName);
};

/* eslint-disable */
applyPolyfills().then(function () {
  return defineCustomElements();
});
var SeAbout = /*@__PURE__*/createReactComponent('se-about');
var SeAccessibilityToggle = /*@__PURE__*/createReactComponent('se-accessibility-toggle');
var SeApp = /*@__PURE__*/createReactComponent('se-app');
var SeAuthentication = /*@__PURE__*/createReactComponent('se-authentication');
var SeBanner = /*@__PURE__*/createReactComponent('se-banner');
var SeBannerItem = /*@__PURE__*/createReactComponent('se-banner-item');
var SeBlock = /*@__PURE__*/createReactComponent('se-block');
var SeBlockContent = /*@__PURE__*/createReactComponent('se-block-content');
var SeBlockFooter = /*@__PURE__*/createReactComponent('se-block-footer');
var SeBlockHeader = /*@__PURE__*/createReactComponent('se-block-header');
var SeBreadcrumb = /*@__PURE__*/createReactComponent('se-breadcrumb');
var SeBreadcrumbItem = /*@__PURE__*/createReactComponent('se-breadcrumb-item');
var SeButton = /*@__PURE__*/createReactComponent('se-button');
var SeCarousel = /*@__PURE__*/createReactComponent('se-carousel');
var SeCarouselItem = /*@__PURE__*/createReactComponent('se-carousel-item');
var SeCarouselPagination = /*@__PURE__*/createReactComponent('se-carousel-pagination');
var SeCheckbox = /*@__PURE__*/createReactComponent('se-checkbox');
var SeChip = /*@__PURE__*/createReactComponent('se-chip');
var SeContainer = /*@__PURE__*/createReactComponent('se-container');
var SeDialog = /*@__PURE__*/createReactComponent('se-dialog');
var SeDialogContent = /*@__PURE__*/createReactComponent('se-dialog-content');
var SeDialogFooter = /*@__PURE__*/createReactComponent('se-dialog-footer');
var SeDialogHeader = /*@__PURE__*/createReactComponent('se-dialog-header');
var SeDivider = /*@__PURE__*/createReactComponent('se-divider');
var SeDropdown = /*@__PURE__*/createReactComponent('se-dropdown');
var SeFab = /*@__PURE__*/createReactComponent('se-fab');
var SeFabItem = /*@__PURE__*/createReactComponent('se-fab-item');
var SeFiltration = /*@__PURE__*/createReactComponent('se-filtration');
var SeFiltrationSmart = /*@__PURE__*/createReactComponent('se-filtration-smart');
var SeFiltrationSmartCheckbox = /*@__PURE__*/createReactComponent('se-filtration-smart-checkbox');
var SeFiltrationSmartDesktopView = /*@__PURE__*/createReactComponent('se-filtration-smart-desktop-view');
var SeFiltrationSmartFacet = /*@__PURE__*/createReactComponent('se-filtration-smart-facet');
var SeFiltrationSmartGroup = /*@__PURE__*/createReactComponent('se-filtration-smart-group');
var SeFiltrationSmartMobileView = /*@__PURE__*/createReactComponent('se-filtration-smart-mobile-view');
var SeFiltrationSmartMobileViewTrigger = /*@__PURE__*/createReactComponent('se-filtration-smart-mobile-view-trigger');
var SeFiltrationSmartResetButton = /*@__PURE__*/createReactComponent('se-filtration-smart-reset-button');
var SeFiltrationSmartTab = /*@__PURE__*/createReactComponent('se-filtration-smart-tab');
var SeFiltrationSmartViewMoreFacetsButton = /*@__PURE__*/createReactComponent('se-filtration-smart-view-more-facets-button');
var SeFiltrationSmartViewMoreRefinementsButton = /*@__PURE__*/createReactComponent('se-filtration-smart-view-more-refinements-button');
var SeFormField = /*@__PURE__*/createReactComponent('se-form-field');
var SeHeader = /*@__PURE__*/createReactComponent('se-header');
var SeIcon = /*@__PURE__*/createReactComponent('se-icon');
var SeIconEcostruxure = /*@__PURE__*/createReactComponent('se-icon-ecostruxure');
var SeIconFile = /*@__PURE__*/createReactComponent('se-icon-file');
var SeIconLifeison = /*@__PURE__*/createReactComponent('se-icon-lifeison');
var SeIconSchneider = /*@__PURE__*/createReactComponent('se-icon-schneider');
var SeLink = /*@__PURE__*/createReactComponent('se-link');
var SeList = /*@__PURE__*/createReactComponent('se-list');
var SeListGroup = /*@__PURE__*/createReactComponent('se-list-group');
var SeListItem = /*@__PURE__*/createReactComponent('se-list-item');
var SeLoading = /*@__PURE__*/createReactComponent('se-loading');
var SePagination = /*@__PURE__*/createReactComponent('se-pagination');
var SeRadio = /*@__PURE__*/createReactComponent('se-radio');
var SeRadioGroup = /*@__PURE__*/createReactComponent('se-radio-group');
var SeSidemenu = /*@__PURE__*/createReactComponent('se-sidemenu');
var SeSidemenuItem = /*@__PURE__*/createReactComponent('se-sidemenu-item');
var SeSkeleton = /*@__PURE__*/createReactComponent('se-skeleton');
var SeSlider = /*@__PURE__*/createReactComponent('se-slider');
var SeSnackbar = /*@__PURE__*/createReactComponent('se-snackbar');
var SeStepper = /*@__PURE__*/createReactComponent('se-stepper');
var SeStepperItem = /*@__PURE__*/createReactComponent('se-stepper-item');
var SeTab = /*@__PURE__*/createReactComponent('se-tab');
var SeTabItem = /*@__PURE__*/createReactComponent('se-tab-item');
var SeTabbar = /*@__PURE__*/createReactComponent('se-tabbar');
var SeTable = /*@__PURE__*/createReactComponent('se-table');
var SeTableGroup = /*@__PURE__*/createReactComponent('se-table-group');
var SeTableGroupHeader = /*@__PURE__*/createReactComponent('se-table-group-header');
var SeTableItem = /*@__PURE__*/createReactComponent('se-table-item');
var SeTableItemHeader = /*@__PURE__*/createReactComponent('se-table-item-header');
var SeTooltip = /*@__PURE__*/createReactComponent('se-tooltip');
var SeTooltipContent = /*@__PURE__*/createReactComponent('se-tooltip-content');
var SeTooltipFooter = /*@__PURE__*/createReactComponent('se-tooltip-footer');
var SeTooltipHeader = /*@__PURE__*/createReactComponent('se-tooltip-header');
var SeVisualLinear = /*@__PURE__*/createReactComponent('se-visual-linear');
var SeVisualRadial = /*@__PURE__*/createReactComponent('se-visual-radial');

export { SeAbout, SeAccessibilityToggle, SeApp, SeAuthentication, SeBanner, SeBannerItem, SeBlock, SeBlockContent, SeBlockFooter, SeBlockHeader, SeBreadcrumb, SeBreadcrumbItem, SeButton, SeCarousel, SeCarouselItem, SeCarouselPagination, SeCheckbox, SeChip, SeContainer, SeDialog, SeDialogContent, SeDialogFooter, SeDialogHeader, SeDivider, SeDropdown, SeFab, SeFabItem, SeFiltration, SeFiltrationSmart, SeFiltrationSmartCheckbox, SeFiltrationSmartDesktopView, SeFiltrationSmartFacet, SeFiltrationSmartGroup, SeFiltrationSmartMobileView, SeFiltrationSmartMobileViewTrigger, SeFiltrationSmartResetButton, SeFiltrationSmartTab, SeFiltrationSmartViewMoreFacetsButton, SeFiltrationSmartViewMoreRefinementsButton, SeFormField, SeHeader, SeIcon, SeIconEcostruxure, SeIconFile, SeIconLifeison, SeIconSchneider, SeLink, SeList, SeListGroup, SeListItem, SeLoading, SePagination, SeRadio, SeRadioGroup, SeSidemenu, SeSidemenuItem, SeSkeleton, SeSlider, SeSnackbar, SeStepper, SeStepperItem, SeTab, SeTabItem, SeTabbar, SeTable, SeTableGroup, SeTableGroupHeader, SeTableItem, SeTableItemHeader, SeTooltip, SeTooltipContent, SeTooltipFooter, SeTooltipHeader, SeVisualLinear, SeVisualRadial };
